import { use, useEffect, useState } from 'react';
import ErrorMessageProviderContext from 'shared/components/error/providers/contexts/error-message-context';

import { useGatewaysContextProvider } from 'features/gateway/context/gateway-provider';
import { useGenerateSecrets } from 'features/gateway/domain/queries/gateway-queries';

export interface IGatewaySettingsViewpointClientHook {
  clientId: string | undefined;
  clientSecret: string;
  generateSecretIsLoading: boolean;
  isGenerateSecretConfirmationOpen: boolean;
  defaultSecret: string;

  generateSecret: () => void;
  submitGenerateSecret: () => void;
  closeGenerateSecretConfirmationPopup: () => void;
}

const useGatewaySettingsViewpointClient = (): IGatewaySettingsViewpointClientHook => {
  const { setErrorMessage } = use(ErrorMessageProviderContext);

  const { gatewayDetailsHook } = useGatewaysContextProvider();

  const defaultSecret = '********';

  const [isGenerateSecretConfirmationOpen, setIsGenerateSecretConfirmationOpen] = useState(false);
  const [clientId, setClientId] = useState(gatewayDetailsHook.currentSelectedGateway?.clientId);
  const [clientSecret, setClientSecret] = useState(defaultSecret);

  const {
    mutate: generateSecrets,
    isPending: generateSecretIsPending,
    isError: generateSecretIsError,
    error: generateSecretError,
    isSuccess: generateSecretIsSuccess,
    data: generateSecretData,
  } = useGenerateSecrets();

  useEffect(() => {
    if (generateSecretIsError && generateSecretError) {
      setErrorMessage(generateSecretError);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [generateSecretIsError]);

  useEffect(() => {
    if (generateSecretData) {
      setClientId(generateSecretData.clientId);
      setClientSecret(generateSecretData.secret);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [generateSecretIsSuccess]);

  useEffect(() => {
    setClientId(gatewayDetailsHook.currentSelectedGateway?.clientId);
  }, [gatewayDetailsHook.currentSelectedGateway]);

  const generateSecret = () => {
    if (clientId && clientId.length > 0) {
      setIsGenerateSecretConfirmationOpen(true);
    } else {
      const gatewayId = gatewayDetailsHook.currentSelectedGateway?.id;
      if (gatewayId) {
        generateSecrets(gatewayId);
      }
      setIsGenerateSecretConfirmationOpen(false);
    }
  };

  const closeGenerateSecretConfirmationPopup = () => setIsGenerateSecretConfirmationOpen(false);

  const submitGenerateSecret = () => {
    const gatewayId = gatewayDetailsHook.currentSelectedGateway?.id;
    if (gatewayId) {
      generateSecrets(gatewayId);
    }
    setIsGenerateSecretConfirmationOpen(false);
  };

  return {
    clientId,
    clientSecret,
    generateSecretIsLoading: generateSecretIsPending,
    isGenerateSecretConfirmationOpen,
    defaultSecret,

    generateSecret,
    submitGenerateSecret,
    closeGenerateSecretConfirmationPopup,
  };
};

export default useGatewaySettingsViewpointClient;
